export default __webpack_public_path__ + "static/media/7.73b61451.jpg";